import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function CookiesPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Cookie Policy | L+TV TÉLÉVISION";
  }, []);

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("legal.cookies.title")}</h1>
        </div>
      </div>
      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto prose prose-sm max-w-none text-foreground-700">
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.cookies.sec1")}</h2>
          <p className="mb-4">{t("legal.cookies.sec1p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.cookies.sec2")}</h2>
          <p className="mb-4">{t("legal.cookies.sec2p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.cookies.sec3")}</h2>
          <p className="mb-4">{t("legal.cookies.sec3p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.cookies.sec4")}</h2>
          <p className="mb-4">{t("legal.cookies.sec4p")}</p>
          <h2 className="text-lg font-bold text-foreground-900 mb-3">{t("legal.cookies.sec5")}</h2>
          <p className="mb-4">{t("legal.cookies.sec5p")}</p>
        </div>
      </div>
    </div>
  );
}